package songwritersnotebook.app.utils

import songwritersnotebook.app.data.ChordDefinition
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.functions
import io.ktor.client.*
import kotlinx.serialization.json.*

class AiChordService(private val httpClient: HttpClient) {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = true
    }

    private fun toNative(element: JsonElement): Any? {
        return when (element) {
            is JsonNull -> null
            is JsonObject -> element.mapValues { toNative(it.value) }
            is JsonArray -> element.map { toNative(it) }
            is JsonPrimitive -> {
                if (element.isString) element.content
                else element.booleanOrNull ?: element.longOrNull ?: element.doubleOrNull ?: element.content
            }
        }
    }

    suspend fun getChordSuggestions(
        prompt: String? = null,
        songId: String,
        songChords: List<ChordDefinition>,
        libraryChords: List<ChordDefinition>,
        count: Int = 5,
        guitarTuning: List<String>,
        guitarCapo: Int
    ): List<ChordDefinition> {
        return try {
            val functions = Firebase.functions("us-central1")
            val callable = functions.httpsCallable("getChordSuggestion")
            
            val songChordsJson = json.encodeToJsonElement(songChords)
            val libraryChordsJson = json.encodeToJsonElement(libraryChords)
            
            val requestMap = mapOf(
                "prompt" to prompt,
                "songId" to songId,
                "songChords" to toNative(songChordsJson),
                "libraryChords" to toNative(libraryChordsJson),
                "count" to count,
                "guitarTuning" to guitarTuning,
                "guitarCapo" to guitarCapo
            )
            
            val result = callable.invoke(requestMap)
            val jsonText = result.data<String>()
            
            val jsonDecoder = Json { ignoreUnknownKeys = true }
            jsonDecoder.decodeFromString<List<ChordDefinition>>(jsonText)
        } catch (e: Exception) {
            e.printStackTrace()
            emptyList()
        }
    }
}
